"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlIVec3Uniform = void 0;
const a_gl_uniform_array_1 = require("./a-gl-uniform-array");
/**
 * @public
 * Wrapper for webgl int32 vector3 uniform.
 */
class GlIVec3Uniform extends a_gl_uniform_array_1.AGlUniformArray {
    bind(renderer) {
        if (!this.isDirty) {
            return;
        }
        const data = this.data;
        renderer.context.uniform3iv(this.uniformLocation, data);
        this.isDirty = false;
    }
}
exports.GlIVec3Uniform = GlIVec3Uniform;
//# sourceMappingURL=gl-i-vec3-uniform.js.map